'use strict';

var _lodash = require('lodash');

exports.initFromMenu = function (menu, numGuests) {
  if (menu.none) {
    return {
      _id: null,
      name: (0, _lodash.get)(menu, 'data.name', 'No Menu Desired'),
      none: true,
      coverImage: null,
      numGuests: null,
      pricePerGuestCents: null
    };
  } else {
    return {
      none: false,
      _id: menu._id,
      name: menu.data.name,
      type: menu.data.type,
      description: menu.data.description,
      photos: menu.data.photos,
      coverIndex: menu.data.coverIndex,
      courses: menu.data.courses,
      coverImage: (0, _lodash.get)(menu, 'coverImage.url'),
      numGuests: numGuests,
      pricePerGuestCents: menu.data.priceInCents,
      isCustom: menu.isCustom
    };
  }
};